// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionNdcModel {
    static getAttributeTypeMap() {
        return PrescriptionNdcModel.attributeTypeMap;
    }
}
PrescriptionNdcModel.discriminator = undefined;
PrescriptionNdcModel.additionalProperties = false;
PrescriptionNdcModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "drugNumber",
        "baseName": "drugNumber",
        "type": "string"
    },
    {
        "name": "strengthDescription",
        "baseName": "strengthDescription",
        "type": "string"
    },
];
//# sourceMappingURL=prescriptionNdcModel.js.map